import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '~/app/components/common/Loader/Loader';
import { useAuth } from '~/app/auth/context/AuthContext';
import { DEFAULT_LANDING_PATH } from '~/app/auth/utils';

export function HomeRedirect() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      navigate(DEFAULT_LANDING_PATH, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  return null;
}
